import { createSlice } from '@reduxjs/toolkit';

import { loggedOut } from '@lib/redux/actions/lifecycle';

/** Redux twin of lib/state/Session.ts (JSAD-7433). */
export interface SessionState {
    bbbPopupSeen: number;
    hasAppStoreUpdate?: boolean;
}

const initialState: SessionState = {
    bbbPopupSeen: 0
};

const sessionSlice = createSlice({
    name: 'session',
    initialState,
    reducers: {
        viewBBBPopup: (state) => {
            state.bbbPopupSeen += 1;
        },
        appStoreUpdateAvailable: (state) => {
            state.hasAppStoreUpdate = true;
        },
        /** `Session.ts:19` — resets the popup counter only; `hasAppStoreUpdate` is kept. */
        resetSession: (state) => {
            state.bbbPopupSeen = 0;
        }
    },
    extraReducers: (builder) => {
        // `clearLoggedInState` → `resetSession()` (useAuth.ts:123).
        builder.addCase(loggedOut, (state) => {
            state.bbbPopupSeen = 0;
        });
    }
});

export const { viewBBBPopup, appStoreUpdateAvailable, resetSession } = sessionSlice.actions;

export const selectSession = (state: { session: SessionState }) => state.session;
export const selectBbbPopupSeen = (state: { session: SessionState }) => state.session.bbbPopupSeen;
export const selectHasAppStoreUpdate = (state: { session: SessionState }) =>
    state.session.hasAppStoreUpdate;

export default sessionSlice.reducer;
